import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Commission, CommissionService } from '../../commission';
import { CALENDAR_FR } from '../../../shared/calendar/calendar.constants';
import { DateUtils } from 'ng-jhipster';


@Component({
    selector: 'jhi-commission-component',
    templateUrl: 'commission.component.html'
})
export class CommissionComponent implements OnInit {

    @Input() commission: Commission;
    @Input() commissions: Commission[];
    @Input() currentLang: string; // Ajout de currentLang
    @Output() commissionsChange: EventEmitter<Commission[]> = new EventEmitter();
    fr: any;

    constructor(
        private dateUtils: DateUtils,
        private commissionService: CommissionService // Injection du service
    ) {}

    ngOnInit() {
        this.fr = CALENDAR_FR;
        if (this.commissions != null) {
            this.commissions.forEach(comm => {
                comm.dateCommission = this.dateUtils.convertDateTimeFromServer(comm.dateCommission);
                comm.datePublication = this.dateUtils.convertDateTimeFromServer(comm.datePublication);
                comm.dateCoupure = this.dateUtils.convertDateTimeFromServer(comm.dateCoupure);
                comm.dateLimiteAvis = this.dateUtils.convertDateTimeFromServer(comm.dateLimiteAvis);
                comm.dateLimiteConfirmation = this.dateUtils.convertDateTimeFromServer(comm.dateLimiteConfirmation);
                comm.heureCoupure = comm.dateCoupure;
                comm.heureCommission = comm.dateCommission;
                comm.heurePublication = comm.datePublication;
                comm.heureLimiteAvis = comm.dateLimiteAvis;
                comm.heureLimiteConfirmation = comm.dateLimiteConfirmation;
            });
        }
    }

    formatDateLimiteConfirmation(commission: Commission): string {
        if (!commission.dateLimiteConfirmation) return null;
        return this.commissionService.formatDateLimiteConfirmation(commission, this.currentLang);
    }

    clearCommission(index: number) {
        this.commissions.splice(index, 1);
        this.commissionsChange.emit(this.commissions);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/commission/commission.component.ts